/**********************************
  wp_fast_ship.js  (Good Earth)

  COOKIE HELPERS ONLY.

  All geolocation was REMOVED from this file. Geo now lives solely in
  worldpantry-ipzipcode.js (the app-proxy version), which is the single
  source that sets the 'zipcode' cookie. The old IPStack block (with its
  hardcoded access_key) and the setTimeout(geoTarget, 1000) auto-submit
  were deleted -- the fast-shipping-logic snippet now polls for the
  'zipcode' cookie and auto-submits once (see
  worldpantry-fast-shipping-logic.liquid).

  All submit / lookup / display / restore behaviour also lives in that
  snippet. This file exists only to provide the cookie helper functions it
  depends on:  setSessionCookie, getSessionCookie, deleteCookie, getCookie.
***********************************/

// Sets a session cookie (no explicit expiry) with the given name and value.
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/";
}

// Gets a cookie with the given name. Returns undefined if not present.
function getSessionCookie(name) {
  var nameKey = name + "=";
  var cDecoded = decodeURIComponent(document.cookie);
  var cArr = cDecoded.split('; ');
  var res;
  cArr.forEach(function (val) {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

// Deletes a cookie by name (expire in the past, same path).
function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

// Legacy-style cookie getter kept for compatibility. Returns "" if not set.
// Used by the geo poller to read the 'zipcode' cookie from ipzipcode.js.
function getCookie(name) {
  if (document.cookie.length > 0) {
    var start = document.cookie.indexOf(name + "=");
    if (start !== -1) {
      start = start + name.length + 1;
      var end = document.cookie.indexOf(";", start);
      if (end === -1) end = document.cookie.length;
      return decodeURIComponent(document.cookie.substring(start, end));
    }
  }
  return "";
}
